var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 362,
    viewBox: "0 0 279 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 1.5H240.5C260.658 1.5 277 17.8416 277 38C277 58.1584 260.658 74.5 240.5 74.5H36.5C17.17 74.5 1.5 90.17 1.5 109.5C1.5 128.83 17.17 144.5 36.5 144.5H241C260.882 144.5 277 160.618 277 180.5C277 200.382 260.882 216.5 241 216.5H37.5C17.6177 216.5 1.5 232.618 1.5 252.5C1.5 272.382 17.6178 288.5 37.5 288.5H101.5C121.382 288.5 137.5 304.618 137.5 324.5C137.5 344.382 153.618 360.5 173.5 360.5H277",
    stroke: "#D6AF66",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector 4.e6bff9bd9fa7b5d102d756a136f418d2.svg";
export { ForwardRef as ReactComponent };